export default __webpack_public_path__ + "static/media/pin.7a1fd2c7.svg";